module.exports = __webpack_public_path__ + "static/media/Ace of Spades.0dac201d.jpg";